<template>
    <v-snackbar
        v-model="snackbar.snackbar"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :top="snackbar.top"
    >
        <span class="text--white">{{ snackbar.message }}</span>
    </v-snackbar>
</template>

<style scoped>
    .text--white {
        font-family: inherit
    }
</style>

<script>

    import {mapState} from "vuex";

    export default {
        name: 'snackBar',
        data() {
            return {}
        },
        computed: {
            ...mapState('app', [
                'snackbar'
            ])
        }
    }

</script>
